module.exports = __webpack_public_path__ + "img/search-2-blue.851715af.svg";